// extracted by mini-css-extract-plugin
export default {"style":"Paper_style__vFzud"};